<div class="grid mt-3 ml-3 overview-details mr-0">
    <div class="col-6 md:col-12 lg:col-6 pl-0 pt-0">

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase category-name font-semibold" translate>sponsor.lbl_sponsor_details</label>
                </div>
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label
                        class="detail-heading">{{cs.getLabelValue('sponsor.fields.sponsor_status.label',attributeLabels,'status')}}</label>
                </div>
                <div class="col-8  pb-1">
                    @for (item of sponserDetails['sponsor_status'] | keyvalue; track item.key) {
                    <label class="detail-value border-round-md status-box" [ngClass]="{
                                'active': item.key?.toLowerCase() === 'active',
                                'inactive': item.key?.toLowerCase() === 'inactive'                                
                            }">{{ item.value }}</label>


                    }

                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label
                        class="detail-heading">{{cs.getLabelValue('sponsor.fields.sponsor_code.label',attributeLabels,'id')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponserDetails?.sponsor_code ?? '-'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label
                        class="detail-heading">{{cs.getLabelValue('sponsor.fields.sponsor_name.label',attributeLabels,'full_legal_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponserDetails?.sponsor_name ?? '-'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label
                        class="detail-heading">{{cs.getLabelValue('sponsor.fields.email.label',attributeLabels,'email_address')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponserDetails?.email ?? '-'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate="sponsor.lbl_postal_address"></label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ formatAddress() }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>sponsor.lbl_phone_number</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{sponserDetails?.contact_number ?? '-'}}</label>
                </div>
            </div>

        </div>
    </div>
</div>